const paths = {
  show: `${process.env.NEXT_PUBLIC_API_HOST}/api/deals/:deal_id/deal_estimation_history_confirmed_files/:id`
};

export const getDownloadPath = (dealId: number, id: number): string =>
  paths.show.replace(':deal_id', String(dealId)).replace(':id', String(id));
